import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const KATEGORI = {
  "truck-pasir": "Truck Pasir",
  "truck-box": "Truck Box",
  "truck-kayu": "Truck Kayu",
  "truck-air": "Truck Air",
};

export const KATEGORI_ORDER = ["truck-pasir", "truck-box", "truck-kayu", "truck-air"];

// Foto & data kategori. Kategori tanpa data asli tetap menampilkan placeholder sampai data diberikan.
export const KATEGORI_META = {
  "truck-pasir": {
    foto: "/images/truck-pasir-1.jpg",
    fotos: ["/images/truck-pasir-1.jpg", "/images/truck-pasir-2.jpg"],
    desc: "15 unit truck pasir dengan dimensi 3,8 m × 1,9 m × 1,0 m dan kapasitas 7.000–8.000 kg untuk mendukung kebutuhan pengiriman dan angkutan Anda.",
    descCard: "Armada andalan untuk pengiriman dan angkutan kebutuhan bisnis Anda.",
    jumlah: "15 unit",
    dimensi: "3,8 m × 1,9 m × 1,0 m (P × L × T)",
    kapasitas: "7.000 – 8.000 kg",
  },
  "truck-box": {
    foto: "/images/truck-box-side.jpg",
    fotos: ["/images/truck-box-side.jpg", "/images/truck-box-front.jpg"],
    desc: "2 unit truck box Mitsubishi Fuso Colt Diesel dengan dimensi 4,5 m × 2,0 m × 2,0 m dan kapasitas 4.000–5.000 kg untuk pengiriman barang bisnis Anda.",
    descCard: "Pengiriman barang yang rapi dan terlindungi di dalam box.",
    jumlah: "2 unit",
    dimensi: "4,5 m × 2,0 m × 2,0 m (P × L × T)",
    kapasitas: "4.000 – 5.000 kg",
  },
  "truck-kayu": {
    foto: "/images/truck-kayu-1.jpg",
    fotos: ["/images/truck-kayu-1.jpg", "/images/truck-kayu-2.jpg"],
    desc: "3 unit truck kayu dengan dimensi 4,5 m × 2,0 m × 1,6 m dan kapasitas 5.000–8.000 kg untuk kebutuhan transportasi barang Anda.",
    descCard: "Transportasi barang dengan bak terbuka yang leluasa.",
    jumlah: "3 unit",
    dimensi: "4,5 m × 2,0 m × 1,6 m (P × L × T)",
    kapasitas: "5.000 – 8.000 kg",
  },
  "truck-air": {
    foto: "/images/truck-air-1.jpg",
    fotos: ["/images/truck-air-1.jpg", "/images/truck-air-2.jpg"],
    desc: "2 unit truck air dengan dimensi 3,2 m × 1,6 m × 1,1 m dan kapasitas 4.000 kg untuk mendukung kebutuhan operasional Anda.",
    descCard: "Mendukung kebutuhan air untuk aktivitas operasional Anda.",
    jumlah: "2 unit",
    dimensi: "3,2 m × 1,6 m × 1,1 m (P × L × T)",
    kapasitas: "4.000 kg",
  },
};

export const STATUS = {
  tersedia: { label: "Tersedia", dot: "bg-gold" },
  disewa: { label: "Disewa", dot: "bg-zinc-400" },
  perawatan: { label: "Perawatan", dot: "bg-red-500" },
};

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -84, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function fileToDataUrl(file, maxSize = 1100) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.82));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
